import { render, staticRenderFns } from "./newsMainContent.vue?vue&type=template&id=576c5c5d&scoped=true"
import script from "./newsMainContent.vue?vue&type=script&lang=js"
export * from "./newsMainContent.vue?vue&type=script&lang=js"
import style0 from "./newsMainContent.vue?vue&type=style&index=0&id=576c5c5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c5c5d",
  null
  
)

export default component.exports